import { useState } from 'react';
import { getAppLanguage } from '../utils/language';
import { writeLanguageToStorage } from '../utils/settingsStorage';

export function normalizeUiLanguage(lang: string): string {
  return lang.toLowerCase().startsWith('en') ? 'en-US' : 'ru-RU';
}

/** Language state for guest screens (login/register) and local persistence. */
export function useAppLanguage() {
  const [language, setLanguageState] = useState(() => getAppLanguage());

  const setLanguage = (lang: string) => {
    const normalized = normalizeUiLanguage(lang);
    writeLanguageToStorage(normalized);
    setLanguageState(normalized);
  };

  return { language, setLanguage };
}
